import { render, staticRenderFns } from "./eltTransfer.vue?vue&type=template&id=61c44ab1&scoped=true&"
import script from "./eltTransfer.vue?vue&type=script&lang=js&"
export * from "./eltTransfer.vue?vue&type=script&lang=js&"
import style0 from "./eltTransfer.vue?vue&type=style&index=0&id=61c44ab1&scoped=true&lang=css&"
import style1 from "./eltTransfer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c44ab1",
  null
  
)

export default component.exports